import {
    PAYOFF_COUPON_FIXED_RATE,
    PAYOFF_COUPON_FIXED_RATE_STEP,
    PAYOFF_COUPON_FIXED_RATE_TYPE
} from './product-capture-field-selectors.consts';

import { FCSelector } from '../../model/form-config.interface';

export const COUPON_FIXED_RATE_TYPE: FCSelector = {
  formControlNames: [PAYOFF_COUPON_FIXED_RATE_TYPE],
  options: [
    {
      id: 'FLAT',
      label: 'Flat',
      effects: [
        {
          formControlNames: [PAYOFF_COUPON_FIXED_RATE_STEP],
          hidden: true,
        },
        {
          formControlNames: [PAYOFF_COUPON_FIXED_RATE],
          hidden: false,
        },
      ]
    },
    {
      id: 'STEPPED',
      label: 'Stepped',
      effects: [
        {
          formControlNames: [
            PAYOFF_COUPON_FIXED_RATE_STEP,
            PAYOFF_COUPON_FIXED_RATE,
          ],
          hidden: false,
        },
      ]
    },
    {
      id: 'CUSTOM',
      label: 'Custom',
      effects: [
        {
          formControlNames: [
            PAYOFF_COUPON_FIXED_RATE,
            PAYOFF_COUPON_FIXED_RATE_STEP,
          ],
          hidden: true,
        },
      ]
    },
  ],
};
